import {
  IAppData,
  IWidgetController,
  IWidgetControllerConfig,
  IWixAPI,
  IControllerConfig,
} from '@wix/native-components-infra/dist/src/types/types';
import { ApiTypes } from '@wix/social-groups-api';
import GroupsController from './GroupsController';
import ExperimentsController from './ExperimentsController';
import { ExperimentsBag } from '@wix/wix-experiments';
import { AppRootProps } from '../types';

class WidgetController implements IWidgetController {
  private readonly groupsController: GroupsController;

  private readonly wixCodeApi: IWixAPI;
  private readonly appParams: IAppData;
  private readonly setProps: (props: Partial<AppRootProps>) => void;
  private config: IControllerConfig;

  constructor(controllerConfig: IWidgetControllerConfig) {
    this.groupsController = new GroupsController(controllerConfig);

    const { appParams, setProps, wixCodeApi, config } = controllerConfig;
    this.wixCodeApi = wixCodeApi;
    this.appParams = appParams;
    this.setProps = setProps;
    this.config = config;
  }

  async pageReady() {
    const [groups, experiments] = await Promise.all([
      this.groupsController.fetchGroups(),
      ExperimentsController.getExperiments(),
    ]);
    this.setInitialProps(groups, experiments);
  }

  updateConfig($w, updatedConfig) {
    this.config = updatedConfig;
    this.setProps({
      styleParams: updatedConfig.style.styleParams,
    });
  }

  get exports() {
    return {};
  }

  private setInitialProps(
    groups: ApiTypes.v1.GroupResponse[],
    experiments: ExperimentsBag,
  ) {
    this.setProps({
      groups,
      actions: {
        createGroup: this.groupsController.createGroup,
        goToGroup: this.groupsController.goToGroup,
        promptLogin: this.promptLogin,
      },
      cssBaseUrl: this.appParams.baseUrls.staticsBaseUrl,
      isUserLoggedIn: this.wixCodeApi.user.currentUser.loggedIn,
      experiments,
      locale: this.getLocale(),
      styleParams: this.config.style.styleParams,
    });
  }

  promptLogin = async () => {
    try {
      const user = await this.wixCodeApi.user.promptLogin({
        lang: this.wixCodeApi.site.language,
      });

      this.groupsController.refreshApiToken(user.instance);

      this.setProps({
        isUserLoggedIn: user.loggedIn,
      });
    } catch (e) {
      // TODO: handle error
      console.error(e);
    }
  };

  private getLocale(): string {
    return this.wixCodeApi.window.locale || 'en';
  }
}

export async function createAppController(
  controllerConfig: IWidgetControllerConfig,
): Promise<IWidgetController> {
  return new WidgetController(controllerConfig);
}
